import { render, staticRenderFns } from "./AiBubbleBottom.vue?vue&type=template&id=1a48a853&scoped=true&"
import script from "./AiBubbleBottom.vue?vue&type=script&lang=ts&"
export * from "./AiBubbleBottom.vue?vue&type=script&lang=ts&"
import style0 from "./AiBubbleBottom.vue?vue&type=style&index=0&id=1a48a853&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a48a853",
  null
  
)

export default component.exports